// 预览框
<template>
  <div class="popup">
    <el-dialog
      :visible.sync="dialogVisible"
      @close="onClose"
      :show-close="false"
      width="670px"
    >
      <div class="content">
        <div class="title">
          <div class="title_top">{{ itemData.subject }}</div>
          <div class="title_bottom">
            <div class="item">
              <div class="item_label">分类：</div>
              <div class="item_value">{{ itemData.categoryName }}</div>
            </div>
            <div class="item">
              <div class="item_label">上传日期：</div>
              <div class="item_value">{{ itemData.updatedAt | timeFormat }}</div>
            </div>
            <div class="item">
              <div class="item_label">价格：</div>
              <div class="item_value" :class="{ red: showMask }">
                ¥{{ itemData.price | priceFormat }}
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <vue-office-docx :src="url" :style="docxStyle" @rendered="onRendered" />
        </div>
        <div class="mask" v-if="showMask">
          <div class="mask_footer">
            <div class="mask_footer_top"></div>
            <div class="mask_footer_btn">
              若需预览本合同模板的全部内容，需
              <span @click="onBuy">进行购买</span>
            </div>
          </div>
        </div>
        <img
          src="@/assets/image/close2.webp"
          class="close"
          alt=""
          srcset=""
          @click="onHide"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueOfficeDocx from "@vue-office/docx";
import "@vue-office/docx/lib/index.css";
export default {
  components: { VueOfficeDocx },
  props: {
    showMask: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      itemData: {
        subject: "",
        url: "",
      },
      docxStyle: {}, // 存储动态缩放样式
    };
  },
  created() {},
  computed: {
    url() {
      if (this.showMask) {
        return this.$oss + this.itemData.previewUrl;
      } else {
        return this.$oss + this.itemData.url;
      }
    },
  },
  methods: {
    onClose() {
      this.onHide();
    },
    onShow(itemData) {
      this.itemData = itemData;
      this.showMask && this.postContractTempPreview();
      this.dialogVisible = true;
    },
    onHide() {
      this.dialogVisible = false;
    },
    onBuy() {
      this.$emit("onBuy", this.itemData);
    },
    postContractTempPreview() {
      this.$api.postContractTempPreview({tempId:this.itemData.tempId});
    },
    onRendered() {
      this.$nextTick(() => {
        // 获取实际内容元素（根据组件内部结构调整选择器）
        const contentEl = this.$el.querySelector(".docx-wrapper > .docx");
        if (!contentEl) return;
        // 获取元素原始宽度（单位：px）
        const originalWidthPx = parseFloat(window.getComputedStyle(contentEl).width);
        console.log(originalWidthPx);
        // 计算缩放比例（目标宽度 197px）
        const targetWidthPx = 670;
        const zoom = targetWidthPx / originalWidthPx;

        // 直接设置 zoom
        this.docxStyle = {
          zoom: zoom, // 直接传递 zoom 值
        };
      });
    },
  },
};
</script>

<style scoped lang="scss">
.popup {
  @include popupNo;
}
.content {
  position: relative;
  border-radius: 4px;
  //  overflow: hidden;
  .title {
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    row-gap: 6px;
    background: linear-gradient(180deg, #e8f3ff 0%, rgba(255, 255, 255, 0.3) 100%);
    border-bottom: 1px solid #eeeeee;
    border-radius: 4px 4px 0 0;
    &_top {
      display: flex;
      justify-content: center;

      font-size: 18px;
      font-weight: 500;
      color: #3d3d3d;
    }
    &_bottom {
      display: flex;
      justify-content: center;
      gap: 60px;
      .item {
        display: flex;
        &_label {
          font-size: 12px;
          font-weight: 350;
          color: #666666;
        }
        &_value {
          font-size: 12px;
          font-weight: 350;
          color: #262626;
        }
        .red {
          color: #f45858;
        }
      }
    }
  }
  .box {
    height: 740px;
    &::v-deep .docx-wrapper {
      padding: 0 !important;

      .docx {
        p,
        span {
          user-select: none !important;
          -webkit-user-select: none !important; /* Safari */
          -moz-user-select: none !important; /* Firefox */
          -ms-user-select: none !important; /* Internet Explorer/Edge */
        }

        padding-top: 0px !important;
        // zoom: 0.248;
      }
    }
    border-radius: 4px;
    overflow: hidden;
  }
  .close {
    width: 28px;
    height: 28px;
    position: absolute;
    bottom: -48px;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;
    border-radius: 4px;
    overflow: hidden;
    // background: #6ff;
    height: 120px;
    &_footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 120px;
      &_top {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
        height: 60px;
      }
      &_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
        background: #ffffff;
        font-size: 16px;
        color: #262626;
        span {
          color: #0062ff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
